import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BrowserEventService, ColorScheme, LocaleSetting } from '@rct/lynx-lobbies-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LynxAuthService } from '../../../services/auth.service';
import { LynxLobbyService } from '../../../services/lobby.service';
import { LynxLocalizeRouterService } from '../../../services/localize-router.service';
import { GameSearchComponent } from '../../game/game-search/game-search.component';

@Component({
    selector: 'lynx-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild(GameSearchComponent, { static: false })
  gameSearchComponent: GameSearchComponent;

  isLoggedIn: boolean;
  isMobile: boolean = this.browserEventService.isMobile();
  logoUrl: string;
  colorScheme: ColorScheme;
  localeSetting: LocaleSetting;
  siteLocale: string;

  private _destroy$ = new Subject<boolean>();

  constructor(
    private authService: LynxAuthService,
    private localizeRouterService: LynxLocalizeRouterService,
    private lobbyService: LynxLobbyService,
    private browserEventService: BrowserEventService
  ) {}

  ngOnInit(): void {
    this.checkIsLoggedIn();
    this.loadTheme();
  }

  backHome(): void {
    this.gameSearchComponent.close();

    this.lobbyService.refreshCategory((err) => {
      console.error('[ERROR] Get Category List Fail!', err);
      this.localizeRouterService.translateRoute('home/category/error');
    });
  }

  checkIsLoggedIn(): void {
    this.authService.isLoggedIn$
      .pipe(takeUntil(this._destroy$))
      .subscribe((isLoggedIn) => (this.isLoggedIn = isLoggedIn));
  }

  loadTheme(): void {
    const defaultLogoUrl = 'assets/images/header/header-logo.png';

    this.lobbyService.theme$
      .pipe(takeUntil(this._destroy$))
      .subscribe((theme) => {
        this.colorScheme = theme.colorScheme;
        this.logoUrl = theme.logo || defaultLogoUrl;
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }
}
